/* eslint-disable import/no-extraneous-dependencies */
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { exhaustMap, map } from 'rxjs/operators';
import {
  LoadingSpinnerService,
  SessionStatus,
} from '@arc/unified-payments-frontend/shared-payment';
import { BaseEffect } from '../../helpers/base-effect';
import { SessionActions } from '../../session-store/actions';
import { selectSessionId } from '../../session-store/selectors/session.selectors';
import { BtPayPaymentInformationActions, PayActions } from '../actions';
import { concatLatestFrom } from '@ngrx/operators';

@Injectable()
export class BtPaySessionEffects extends BaseEffect {
  constructor(
    private store: Store,
    actions$: Actions,
    loadingSpinnerService: LoadingSpinnerService,
  ) {
    super(actions$, loadingSpinnerService);
  }

  setEmailRecipients$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SessionActions.GetSessionSummarySuccessAction),
      map((action) => action.payload.contacts),
      exhaustMap((emailRecipients) => {
        return of(PayActions.SetEmailRecipientsAction({ emailRecipients }));
      }),
    ),
  );

  updateSessionStatusToSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BtPayPaymentInformationActions.ExecutePaymentPreviewSuccessAction),
      concatLatestFrom(() => [this.store.select(selectSessionId)]),
      exhaustMap(([, sessionId]) =>
        of(
          SessionActions.UpdateTransactionStatus({
            payload: {
              sessionId,
              status: SessionStatus.Success,
            },
          }),
        ),
      ),
    ),
  );

  updateSessionStatusToActive$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        BtPayPaymentInformationActions.ExecutePaymentPreviewBadRequestErrorAction,
      ),
      concatLatestFrom(() => [this.store.select(selectSessionId)]),
      exhaustMap(([, sessionId]) =>
        of(
          SessionActions.UpdateTransactionStatus({
            payload: {
              sessionId,
              status: SessionStatus.Active,
            },
          }),
        ),
      ),
    ),
  );
}
